import { Modelo } from 'helper/windx';

// Default e teto do `semanas_futuras` no BE (contrato sm/chart-data v4.1,
// `SEMANAS_FUTURAS_DEFAULT` e `LIMITE_SEMANAS_FUTURAS_MAX`).
const SEMANAS_FUTURAS_DEFAULT = 5;
const SEMANAS_FUTURAS_MAX = 10;
const DIAS_POR_SEMANA = 7;

/**
 * Quantas semanas operativas o grafico semanal do WEOL-SM pede ao BE
 * (`semanas_futuras` do `sm/chart/data`), a partir do horizonte dos modelos
 * marcados.
 *
 * Por que derivar (WEOL-SM #99): o BE devolve as N primeiras semanas da rodada
 * de cada modelo. Com N fixo em 5, o ONS + Climatologia (fecha o mes
 * operativo: de 4 a 10 semanas, `dias_previsao` 70) perderia ate metade do
 * horizonte. Regra do contrato: `ceil(max(dias_previsao dos marcados) / 7)`,
 * entre 1 e 10 — o ONS e os modelos de Medio Prazo (35 dias) seguem com 5, e
 * modelo com menos semanas que N devolve as que tem.
 *
 * Fallback 5 (o default do BE) quando nao ha horizonte conhecido: nenhum modelo
 * marcado, painel-options ainda carregando (lista vazia), id fora do painel ou
 * modelo sem `dias_previsao` (0 ou ausente).
 */
// Export nomeado, como os outros `derivar*` de helper/windx.
// eslint-disable-next-line import/prefer-default-export
export function derivarSemanasFuturasSM(
  idsSelecionados: number[],
  modelos: Pick<Modelo, 'id' | 'dias_previsao'>[],
): number {
  const horizontes = idsSelecionados
    .map((id) => modelos.find((m) => m.id === id)?.dias_previsao ?? 0)
    .filter((dias) => dias > 0);

  if (horizontes.length === 0) return SEMANAS_FUTURAS_DEFAULT;

  const semanas = Math.ceil(Math.max(...horizontes) / DIAS_POR_SEMANA);
  return Math.min(SEMANAS_FUTURAS_MAX, Math.max(1, semanas));
}
